import Image from "next/image";
import { memo, useState } from "react";

const ServiceFaqs = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="py-16 px-4 md:px-10">
      <div>
        <h2 className="text-4xl leading-snug md:text-3xl lg:text-6xl lg:leading-snug font-medium mb-2">
          <span>FAQs</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-2 justify-between">
        {data.map((value, index) => (
          <div key={index}>
            <div className="md:border md:border-solid md:border-gray-400/20 rounded-lg mb-0 my-4">
              <div
                className="text-left py-4 md:px-5 mr-4 md:mx-4 flex justify-between items-center h-24 cursor-pointer"
                onClick={() => onItemClick(index)}
              >
                <h4 className="font-normal text-lg md:text-xl flex items-center text-black w-11/12">
                  <span className="mr-4 md:mr-12">
                    {index > 10 ? index + 1 : "0" + (index + 1)}.
                  </span>
                  <span className="mr-4">{value.question}</span>
                </h4>
                <span className="flex">
                  {index === activeIndex ? (
                    <Image
                      src="/assets/common/minus.webp"
                      width={20}
                      height={4}
                      alt="minus"
                    />
                  ) : (
                    <Image
                      src="/assets/common/plus.webp"
                      width={20}
                      height={20}
                      alt="plus"
                    />
                  )}
                </span>
              </div>
              <div
                className={`text-base ml-6 md:ml-24 text-justify px-5 pb-4 text-black opacity-60 [&_a]:text-blue-500 ${
                  index === activeIndex ? "block" : "hidden"
                }`}
                dangerouslySetInnerHTML={{ __html: value.answer }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(ServiceFaqs);
